/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/anchor-is-valid */
// import {Editor} from '@tinymce/tinymce-react'

import axios from 'axios'
import i18next from 'i18next'
import React, {useCallback, useEffect, useRef, useState} from 'react'
import {FloatingLabel, Spinner} from 'react-bootstrap'
import Button from 'react-bootstrap/Button'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import Row from 'react-bootstrap/Row'
import {useTranslation} from 'react-i18next'
import {useNavigate, useParams} from 'react-router-dom'
import swal from 'sweetalert'
import {KTSVG} from '../../../_metronic/helpers'
import {PageTitle} from '../../../_metronic/layout/core'
import {create, deleteFile, getFile} from '../../../api/modules/file'
import {getPlant2} from '../../../api/modules/getdatalist'
import {approveSIP, generateOTP, getAccesses, getPOApproved, getPOforSIP, getSIPDetail, rejectSIP, resubmitSIP, revisionSIP, signingDocument, unduhSIP} from '../../../api/modules/sip'
import {ViewLetter} from '../../../components/Letter/ViewLetter'
import {PopoverText} from '../../../components/Popover/Popover'
import AddRemoveJadwal from './AddRemoveJadwal'
import CustomUseEffect from './sip/CustomUseEffect'
import {fetchPOApproved, headers} from '../../../services/fetcher'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {resetFilterPOApproved, sipSelector} from '../../../redux/slices/sipSlices'
import {objToParams} from '../../../utils/objToParams'
import {getRoleFlagList} from '../../../api/modules/master-data/master_2'
import {MultiSelect} from 'react-multi-select-component'
import {PriceFormater} from '../../../components/mikro/PriceFormater'
import {authSelector} from 'src/redux/slices/authSlices'
import {HakAkses} from 'src/components/mikro/getHakAkses'
import {FieldProductSpec} from 'src/components/FieldProductSpec'
import {CheckSameIDAttachment} from 'src/components/mikro/CheckSameIDAttachment'
import {FindTodayDate_DDMMYY} from 'src/components/mikro/FindTodayDate_DDMMYY'
import Skeleton from 'react-loading-skeleton'
import dateformat from 'src/utils/dateformat'
import {getForModule} from 'src/api/modules/configuration/signing'
import ApprovalSIPDetailForm from './sip/Form'
import ApprovalSIPDetailLetterContent from './sip/LetterContent'
import ApprovalSIPDetailTable from './sip/Table'
import ApprovalSIPDetailChooseItem from './sip/ChooseItem'
import { setGetNotif } from 'src/_metronic/redux/content'
import { useDispatch, useSelector } from 'react-redux'
import { ModalInputAndGenerateOTP } from './ModalInputAndGenerateOTP'
import { InputFile } from 'src/app/components/InputFile'
import { handleDownloadAttachment } from 'src/app/helpers/file'
import { SIPHistories } from '../si/SIPHistories'
import { ApprovalHistoryPreview } from '../si/ApprovalHistoryPreview'

const ApprovalSIPDetail: React.FC = () => {
  const {roleId} = useAppSelector(authSelector)
  const {filterPOApproved} = useAppSelector(sipSelector)
  const dispatch = useAppDispatch()
  const hakAkses = HakAkses()

  const [show1, setShow1] = useState(false)
  const [show2, setShow2] = useState(false)
  const [show3, setShow3] = useState(false)
  const [show4, setShow4] = useState(false)
  const [showLetter, setShowLetter] = useState(false)
  const [isLoadingModal, setIsLoadingModal] = useState(false)

  const [findocState, setFindocState] = useState(false)
  const [findoc, setFindoc] = useState('')
  const [prinout, setPrintout] = useState('')
  const [printoutState, setPrinoutState] = useState(false)
  // const [approvalState, setApprovalState] = useState(false)
  const handleClose1 = () => setShow1(false)
  const handleShow2 = () => setShow2(true)
  const handleClose4 = () => setShow4(false)
  const handleShow4 = () => {
    setSearchpo('')
    setSearchname('')
    setSearchSektor('')
    setShow4(true)
    dispatch(resetFilterPOApproved())
  }

  let changes = 0

  const {t} = useTranslation()
  const [btnLoading, setBtnLoading] = useState(false)
  const [showApprove, setShowApprove] = useState(false)

  const notif = useSelector((state: any) => state.notif.getNotif)
  const navigate = useNavigate()
  const dispath = useDispatch()

  //#region
  const [fullPO, setFullPO] = useState<any[]>([])
  const [orderSelect, setOrderSelect] = useState<any[]>([])
  const [orderPelanggan, setOrderPelanggan] = useState('')
  const [orderPelangganValue, setOrderPelangganValue] = useState('')
  const [customerCode, setCustomerCode] = useState('')
  const [customerName, setCustomerName] = useState('')
  const [customerAddress, setCustomerAddress] = useState('')
  const [perihal, setPerihal] = useState('')
  const [perihalTanggal, setPerihalTanggal] = useState('')
  const [addedOrder, setAddedOrder] = useState<any[]>([])
  const [indexOrder, setIndexOrder] = useState<any[]>([])
  const [isAdded, setIsAdded] = useState(true)
  const [totalPrice, setTotalPrice] = useState(0)
  const [totalQuantum, setTotalQuantum] = useState(0)
  const [plant, setPlant] = useState('')
  const [plantDesc, setPlantDesc] = useState('')
  const [idPengajuan, setIDPengajuan] = useState('')
  const [subID, setSubID] = useState([])
  const [fullPlant, setFullPlant] = useState<any[]>([])
  const [dist, setDist] = useState('')
  const [sales, setSales] = useState('')
  const [fullRole, setFullRole] = useState<any[]>([])
  const [tempRole, setTempRole] = useState<any[]>([])
  const [matNumber, setMatNumber] = useState('')
  const [grandtotal, setGrandtotal] = useState(0)
  const [fullID, setFullID] = useState<any[]>([])
  const [showDetail, setShowDetail] = useState(false)
  const [custAccount, setCustAccount] = useState('')
  const [lain, setLain] = useState<any>("")
  const [footerContent, setFooterContent] = useState("")
  const [bodyContent, setBodyContent] = useState("")
  const [sektorID, setSektorID] = useState('')
  const [detailOrder, setDetailOrder] = useState<any>({})
  const [retailFlag, setRetailFlag] = useState('')
  const [kepada, setKepada] = useState('')
  const [signername, setSignerName] = useState('')
  const [singerposition, setSignerPositon] = useState('')
  const [paymentMethod, setPaymentMethod] = useState('')
  //#endregion

  const [showUpload, setShowUpload] = useState(false)
  const [allFiles, setAllFiles] = useState<any[]>([])
  const [files, setFiles] = useState({file: null})
  const [namaFile, setNamaFile] = useState('')
  const [description, setDescription] = useState('')
  const [isPrivate, setIsPrivate] = useState(false)
  const [dataType, setDataType] = useState('')
  const [subOrderID, setSubOrderID] = useState('')
  const [provinceName, setProvinceName] = useState('')
  const [cityName, setCityName] = useState('')
  const [productName, setProductName] = useState('')
  const [selectedIndex, setSelectedIndex] = useState<any>([])
  const [fixedQuantum, setFixedQuantum] = useState('')
  const [idSektor, setIDSector] = useState(0)
  const [param, setParam] = useState('')
  const [customerTitle, setCustomerTitle] = useState('')
  const [accesses, setAccesses] = useState<any>()
  const [isFetchingPOApproved, setIsFetchingPOApproved] = useState(false)
  const [fileBox, setFileBox] = useState<any>({})
  const [loading, setLoading] = useState(false)
  const [showRevision, setShowRevision] = useState(false)
  const [showReject, setShowReject] = useState(false)
  const [approveFlag, setApproveFlag] = useState(false)
  const [singingFlag, setSigningFlag] = useState(false)
  const [showSigning, setShowSigning] = useState(false)
  const [showSave, setShowSave] = useState(false)
  const [rejectNote, setRejectNote] = useState(false)
  const [attachmentType, setAttachmentType] = useState('order-item')
  const [orderPaymentTypes, setOrderPaymentTypes] = useState<String[]>([])
  const [SIPNumber, setSIPNumber] = useState<any>("")
  const [tempStatus, setTempStatus] = useState<any>()
  const [regardingSIP, setRegardingSIP] = useState('')
  const [regardingSIPDesc, setRegardingSIPDesc] = useState('')
  const [revisi_count, setRevisi_count] = useState('')
  const [showPreviewForm, setShowPreviewForm] = useState(false)
  const [status, setStatus] = useState<any>()
  const [reviewers, setReviewers] = useState<any[]>([])
  const [approvers, setApprovers] = useState<any[]>([])

  const signingModulePayload = {
    module: 'SIP',
    sector_id: null,
    total_quantum: 0,
  }
  const params = useParams()
  const SIPId = params.id

  const getSIP = async () => {
    setLoading(true)
    
    const res = await getSIPDetail(params.id, localStorage.getItem('credential'))

    if (!res.data.error) {
      const data = res.data.data
      setIDPengajuan(data.order_sub_id)
      setSIPNumber(data.SIP_number)
      setCustomerName([
        data.customer?.title,
        data.customer?.name
      ].filter((x) => x).join(". "))
      setSignerName(data.signer_name)
      setSignerPositon(data.signer_position)

      if(data.valid_date_from) setDateFrom(data.valid_date_from?.split(" ")[0])
      if(data.valid_date_to) setDateTo(data.valid_date_to?.split(" ")[0])
      if(data.valid_date_to) setPerihalTanggal(data.estimate_date?.split(" ")[0])
      
      setKepada(data.kepada)
      setCustomerCode(data.customer?.customer_code)
      setCustomerAddress(data.customer?.address)
      setPaymentMethod(data.payment_method_info)
      setPerihal(data.perihal)

      setBodyContent(data.body_content)
      setLain(data.lain_lain)
      setFooterContent(data.footer_content)
      setTempStatus(data.temp_status)
      setStatus(data.status)
      setRegardingSIP(data.sip_type)
      setRegardingSIPDesc(data.sip_type_desc)
      setRevisi_count(data.amendment_counting)

      setReviewers(data.sip_reviewers)
      setApprovers(data.sip_approvers)

      const _payment_types: String[] = []
      data.order_sub_details?.forEach((value: any) => {
        if(value?.sector){
          setPreviewSector(value?.sector?.name)
        }

        if(value?.payment_type_1_desc && !_payment_types.includes(value?.payment_type_1_desc)) {
          _payment_types.push(value?.payment_type_1_desc)
        }
        if(value?.payment_type_2_desc && !_payment_types.includes(value?.payment_type_2_desc)) {
          _payment_types.push(value?.payment_type_2_desc)
        }
      })
      setOrderPaymentTypes(_payment_types)

      setAddedOrder(data.order_sub_details)
      getOrder(data.order_sub_id)

      setApproveFlag(data.show_btn_approve)
      setSigningFlag(data.show_btn_signing)

      setShowPreviewForm(data.show_btn_approve)
    }
    setLoading(false)
  }

  const formattingTon = (ton: any) => {
    let tempTon = parseFloat(ton)
    let temp = ''
    if (i18next.language == 'en') {
      temp = tempTon.toLocaleString('en', {maximumFractionDigits: 4})
    } else {
      temp = tempTon.toLocaleString('id', {maximumFractionDigits: 4})
    }
    setFixedQuantum(temp)
  }
  // console.log(indexOrder, 'index order')

  const ambilAttachment = async (id: any, type: any = null) => {
    setIsLoadingModal(true)

    if (type) setParam(type)
    await getFile(type || param, id, localStorage.getItem('credential')!).then((res) => {
      setAllFiles(res.data.data)
      setIsLoadingModal(false)
    })
  }

  const handleShowAttachment = (data: any) => {
    let tmp: any[] = []
    let idUser = localStorage?.getItem('user-id')
    data.forEach((item: any) => {
      if (item.private) {
        if (accesses.attachment) {
          return tmp.push(item)
        } else if (idUser == item.user_id) {
          return tmp.push(item)
        } else {
        }
      } else {
        return tmp.push(item)
      }
    })
    setAllFiles(tmp)
  }

  const clearFile = () => {
    const inputfile = document.getElementById('upload') as HTMLInputElement
    inputfile.value = ''
    const inputPrivate = document.getElementById('isPrivate1') as HTMLInputElement
    inputPrivate.checked = false
  }

  const deleteAttachment = async (id: any) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        await deleteFile(id)
          .then(() => {
            swal({
              closeOnClickOutside: false,
              title: t('Dokumen Berhasil Dihapus'),
              icon: 'success',
            })
            ambilAttachment(subOrderID)
          })
          .catch((error) => {
            swal({
              title: error.response.data,
              icon: 'error',
            })
          })
      }
    })
  }

  const handleUpload = async () => {
    setBtnLoading(true)
    let file = files.file
    let formdata = new FormData()
    let temparray: any[] = []
    if (tempRole.length > 0) {
      tempRole.forEach((data: any) => {
        temparray.push(data.value)
      })
    }
    formdata.append('file_r', file!)
    formdata.append('name', namaFile!)
    formdata.append('description', description!)
    formdata.append('attach_parent', subOrderID)
    formdata.append('file_type', dataType)
    formdata.append('private', isPrivate.toString())
    formdata.append('roles', JSON.stringify(temparray))
    formdata.append('credentials', localStorage.getItem('credential')!)
    // console.log(formdata)
    await create(param, formdata)
      .then((res) => {
        swal({
          title: `${t('document uploaded successfully')}`,
          icon: 'success',
        }).then(() => {
          setNamaFile('')
          setDescription('')
          setDataType('')
          setIsPrivate(false)
          setFiles({file: null})
          clearFile()
        })
        ambilAttachment(subOrderID)
      })
      .catch(function (error) {
        swal({
          title: t(error.response.data.message),
          icon: 'error',
        })
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const [previewSector, setPreviewSector] = useState('')

  const getOrder = async (e: any) => {
    // setAddedOrder([])
    setIndexOrder([])
    setSelectedIndex([])
    
    const date = document.getElementById('inputdate') as HTMLInputElement
    if (date != null) date.value = ''
    const date2 = document.getElementById('inputdate2') as HTMLInputElement
    if (date2 != null) date2.value = ''
    const date3 = document.getElementById('inputdate3') as HTMLInputElement
    if (date3 != null) date3.value = ''

    if (e !== null) {
      handleClose4()
    }
    const res = await getPOforSIP(e, localStorage.getItem('credential')!)

    if (!res.data.error) {
      let tempArray: any[] = []
      res.data.data.children.forEach((item: any) => {
        if (item?.sector) {
          setPreviewSector(item?.sector?.name)
        }
        tempArray.push(item.id)
      })
      setFullID(tempArray)

      const _order_select :any[] = []
      const _selected_index : number[] = addedOrder.map((item: any, key: number) => key)
      res.data.data.children.forEach((item: any, key: number) => {
        let inArr = addedOrder.map((it: any) => it.id)
        
        if(!inArr.includes(item.id)){
          _order_select.push(item)
        }
      })
      
      setOrderSelect(_order_select)
      setSelectedIndex(_selected_index)

      setCustAccount(res.data.data.customer?.customer_account_group)
      setOrderPelanggan(
        res.data.data.customer?.title
          ? res.data.data.customer?.title + ' ' + res.data.data.customer?.name
          : res.data.data.customer?.name
      )
      setOrderPelangganValue(res.data.data.customer_id)
      setPerihal(res.data.data.regarding)
      setDist(res.data.data.distribution_channel)
      setSektorID(res.data.data.sector_id)
      setCustomerTitle(res.data.data.customer?.title)
      // setApprovalState(res.data.data.customer?.customer_account_group)

      signingModulePayload.sector_id = res.data.data?.sector_id
      signingModulePayload.total_quantum = res.data.data?.total_fixed_quantum
      loadSigningConfig()
    }
    setIsAdded(false)
  }

  const onclickCheckBox = (index: any) => {
    const isChecked = document.getElementById(`checkbox${index}`) as HTMLInputElement
    const tempArray: any[] = indexOrder
    let temp = parseInt(isChecked.value)
    if (isChecked.checked) {
      tempArray.push(temp)
    } else {
      const tempindex = tempArray.indexOf(temp)
      tempArray.splice(tempindex, 1)
    }
    setIndexOrder(tempArray)
  }

  const addInOrder = (type: any) => {
    // console.log(indexOrder, orderSelect)
    // return
    const tempArray: any[] = [...addedOrder]
    const tempindex: any[] = [...selectedIndex]
    const tempSelect: any[] = [...orderSelect]
    let tempPrice = 0
    let tempQuantum = 0
    let grandtot = 0
    if (type == 'all') {
      orderSelect.forEach((value: any, index: number) => {
        tempArray.push(value)
        tempindex.push(indexOrder.length + index)
        tempPrice = tempPrice + parseFloat(value?.fixed_price)
        tempQuantum = tempQuantum + parseFloat(value?.fixed_quantum)
        grandtot =
          grandtot +
          parseFloat(value?.fixed_price) *
            parseFloat(value?.fixed_quantum)
      })
    } else {
      if (indexOrder.length < 1) {
        swal({
          title: `${t('item tidak boleh kosong')}`,
          icon: 'error',
        })
        return
      } else {
        indexOrder.forEach((value: any, index: any) => {
          tempArray.push(orderSelect[value])
          tempindex.push(indexOrder.length + index)
          tempSelect.splice(value, 1)
          tempPrice = tempPrice + parseFloat(orderSelect[index]?.fixed_price)
          tempQuantum = tempQuantum + parseFloat(orderSelect[index]?.fixed_quantum)
          grandtot =
            grandtot +
            parseFloat(orderSelect[index]?.fixed_price) *
              parseFloat(orderSelect[index]?.fixed_quantum)
        })
        setIsAdded(true)
      }
    }
    // setInitialFooterContent(
    //   `<p>Selanjutnya, mengacu Surat Perjanjian Jasa Pemasaran No. 071/A/KU/G12/SP/2021 dan guna proses lebih lanjut terkait Penjualan Produk Non Subsidi Dalam Negeri & Ekspor, agar ${tempArray[0]?.produsen?.name} dapat melakukan proses penerbitan dokumen transaksi jual beli dengan pembeli tersebut pada kesempatan pertama</p>`
    // )
    // setFooterContent(
    //   `<p>Selanjutnya, mengacu Surat Perjanjian Jasa Pemasaran No. 071/A/KU/G12/SP/2021 dan guna proses lebih lanjut terkait Penjualan Produk Non Subsidi Dalam Negeri & Ekspor, agar ${tempArray[0]?.produsen?.name} dapat melakukan proses penerbitan dokumen transaksi jual beli dengan pembeli tersebut pada kesempatan pertama</p>`
    // )

    setIndexOrder([])
    setSelectedIndex(tempindex)
    setOrderSelect(tempSelect)
    setAddedOrder(tempArray)
    setShow2(false)
    setTotalPrice(tempPrice)
    setTotalQuantum(tempQuantum)
    setGrandtotal(grandtot)
    // console.log(addedOrder, ' addedOrder', tempPrice, ' tempprice ', tempQuantum, ' tempquantum')
    signingModulePayload.total_quantum = tempQuantum
    loadSigningConfig()
  }

  CustomUseEffect(() => {
    let tempPrice = 0
    let tempQuantum = 0
    let grandtot = 0
    addedOrder.forEach((value) => {
      tempPrice = tempPrice + parseFloat(value.fixed_price)
      tempQuantum = tempQuantum + parseFloat(value.fixed_quantum)
      grandtot = grandtot + parseFloat(value.fixed_price) * parseFloat(value.fixed_quantum)
    })
    setTotalPrice(tempPrice)
    setTotalQuantum(tempQuantum)
    setGrandtotal(grandtot)
    if (addedOrder.length < 1) {
      const date = document.getElementById('inputdate') as HTMLInputElement
      if (date != null) date.value = ''
      const date2 = document.getElementById('inputdate2') as HTMLInputElement
      if (date2 != null) date2.value = ''
      const date3 = document.getElementById('inputdate3') as HTMLInputElement
      if (date3 != null) date3.value = ''
      const assname = document.getElementById('assname') as HTMLInputElement
      if (assname != null) assname.value = ''
      const kep = document.getElementById('kepada') as HTMLInputElement
      if (kep != null) kep.value = ''
      const asspos = document.getElementById('asspos') as HTMLInputElement
      if (asspos != null) asspos.value = ''
      const metodepembayaran = document.getElementById('metodepembayaran') as HTMLInputElement
      if (metodepembayaran != null) metodepembayaran.value = ''
    }
  }, [addedOrder])

  const lang = i18next.language
  const [dateFrom, setDateFrom] = useState('')
  const [dateTo, setDateTo] = useState('')

  const handleSave = async () => {
    setBtnLoading(true)
    const tempfiles: any[] = []
    attachment?.forEach((data: any, _index: any) => {
      tempfiles.push(data)
      if (tempfiles?.length > -1) {
        const temp = data?.file_r.split(',')
        if (temp[1] != undefined) tempfiles[_index].file_r = temp[1]
      }
    })
    const tempid: string[] = []
    addedOrder.forEach((id) => {
      tempid.push(id.order_sub_item_id || id.id)
    })
    const res = await resubmitSIP(params.id, {
      id_pengajuan_order: idPengajuan,
      customer: orderPelangganValue,
      perihal: perihal,
      estimate_date: perihalTanggal,
      valid_date_from: dateFrom,
      valid_date_to: dateTo,
      order_sub_detail_id: tempid,
      lang: lang,
      attachments: tempfiles,
      lain_lain: lain,
      kepada: kepada,
      signer_name: signername,
      signer_position: singerposition,
      payment_method_info: paymentMethod,
      body_content: bodyContent,
      footer_content: footerContent,
      is_update: true
    })
      .then((res: any) => {
        swal({
          title: `${t('SIP Saved Successfully')}`,
          icon: 'success',
        }).then(() => {
          setBtnLoading(false)
          setShowSave(false)
          getSIP()
        })
      })
      .catch((err: any) => {
        swal({
          title: `${t(err.response.data.message)}`,
          icon: 'error',
        })
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const removeSubOrder = (index: any) => {
    swal({
      title: `${t('apakahAndaYakin')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then((accept) => {
      if (accept) {
        const temp: any = [...addedOrder]
        const temp2: any = [...selectedIndex]
        const temp3: any = [...orderSelect]

        temp3.push(temp[index])
        setOrderSelect(temp3)
        temp.splice(index, 1)
        setAddedOrder(temp)
        temp2.splice(index, 1)
        setSelectedIndex(temp2)
        console.log([temp3, orderSelect])

        let tempTotalQuantum = 0
        temp.forEach((item: any) => {
          tempTotalQuantum += item.fixed_quantum
        })
        signingModulePayload.total_quantum = tempTotalQuantum
        loadSigningConfig()
        swal({
          title: `${t('deleted successfully')}`,
          icon: 'success',
        })
      }
    })
  }

  useEffect(() => {
    const getSO = async () => {
      await getPOApproved(localStorage.getItem('credential')).then((res) => {
        setFullPO(res.data.data.data)
      })
    }

    getSO()
    let today = new Date()
    let dd = String(today.getDate()).padStart(2, '0')
    let mm = String(today.getMonth() + 1).padStart(2, '0') //January is 0!
    let yyyy = today.getFullYear()
    setDateNow(dd + '-' + mm + '-' + yyyy)

    const getAccessMenu = async () => {
      const res = await getAccesses(roleId)
      setAccesses(res.data.data)
    }

    const getAllRoleList = async () => {
      const res = await getRoleFlagList()
      setFullRole(res.data.data)
    }
    getAllRoleList()
    getAccessMenu()
    getSIP()
  }, [])

  const separator = (value: any, left: any, right: any) => {
    const temp = value.split('~#~')
    left(temp[0])
    right(temp[1])
  }

  CustomUseEffect(() => {
    const plantData = async () => {
      await getPlant2(sales, dist, matNumber).then((res) => {
        setFullPlant(res.data.data)
      })
    }

    plantData()
  }, [sales])

  const [attachment, setAttachment] = useState<any[]>([])
  const [files2, setFiles2] = useState<any>()
  const [datenow, setDateNow] = useState('')

  const [numberURL, setNumberURL] = useState([])

  const paginateNumber = async (url: string) => {
    setIsFetchingPOApproved(true)

    const credentials = localStorage.getItem('credential')
    const endpoint = `${url}&credentials=${credentials}&${objToParams(filterPOApproved)}`
    const token = localStorage.getItem('token') as string
    const res = await axios.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})

    setFullPO(res.data.data.data)
    setNumberURL(res.data.data.links)
    setIsFetchingPOApproved(false)
  }

  //#region state for search
  const [searchpo, setSearchpo] = useState('')
  const [searchname, setSearchname] = useState('')
  const [searchsektor, setSearchSektor] = useState('')
  const [revisionNote, setRevisionNote] = useState('')

  const onFetchPOApproved = useCallback(() => {
    setIsFetchingPOApproved(true)
    fetchPOApproved(filterPOApproved).then((res: any) => {
      setFullPO(res.data.data.data)
      setNumberURL(res.data.data.links)
      setIsFetchingPOApproved(false)
    })
  }, [filterPOApproved])

  useEffect(() => {
    const getData = setTimeout(() => onFetchPOApproved(), 1000)
    return () => clearTimeout(getData)
  }, [onFetchPOApproved])
  //#endregion
  const handleShowValue = (enduser: any) => {
    let temparray: any[] = enduser.split(',')
    let temp = ''
    temparray.forEach((element: any, index: any) => {
      if (index + 1 == temparray.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return temp
  }

  const [previewSegment, setPreviewSegment] = useState<any[]>([])

  const LetterData = {
    kepada: kepada,
    produsen: addedOrder[0]?.produsen?.name,
    customer: customerTitle ? customerTitle + ' ' + customerName : customerName,
    subItem: addedOrder,
    dateFrom: dateFrom,
    dateTo: dateTo,
    includePpn: addedOrder[0]?.include_ppn,
    paymentInfo: paymentMethod,
    paymentMethod: addedOrder,
    lainlain: lain,
    signername: signername,
    singerposition: singerposition,
    sector: sektorID,
    tanggalApprove: FindTodayDate_DDMMYY(''),
    noSIP: SIPNumber,
    tipePembayaranSIP: paymentMethod || orderPaymentTypes?.join(", "),
    footerContent: footerContent ? footerContent : '',
    bodyContent: bodyContent ? bodyContent : '',
    sectorName: previewSector,
    segments: previewSegment,
    regardingSIP: regardingSIP,
    regardingSIPDesc: regardingSIPDesc,
    revisi_count: revisi_count,
  }

  function handleShowRoleName(role: any) {
    let temp = ''
    role.forEach((element: any, index: any) => {
      if (index + 1 == role.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return temp
  }

  const loadSigningConfig = async () => {
    // setSignerName('')
    // setSignerPositon('')
    setBtnLoading(true)

    const res = await getForModule({
      ...signingModulePayload,
      sector_id: sektorID,
    })
      .then((res: any) => {
        const resp = res.data.data
        if (resp) {
          if (!signername) {
            setSignerName(resp.signer_name)
          }
          if (!singerposition) {
            setSignerPositon(resp.signer_position)
          }
        }
      })
      .catch((err: any) => {
        swal({
          title: `${t(err.response.data.message)}`,
          icon: 'error',
        })
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  useEffect(() => {
    setPreviewSegment([])
    let _segments: any[] = []
    addedOrder.forEach((item: any) => {
      if (item.segment_name && !_segments.includes(item.segment_name)) {
        _segments.push(item.segment_name)
      }
    })
    setPreviewSegment(_segments)
  }, [addedOrder])

  const handleRevision = async () => {
    setBtnLoading(true)
    await revisionSIP(parseInt(params.id!), revisionNote, i18next.language)
      .then((res: any) => {
        dispath(setGetNotif(!notif))
        if (!res.data.error) {
          swal({
            title: `${t('Berhasil Revisi SIP')}`,
            icon: 'success',
          }).then(() => {
            setShowRevision(false)
            navigate('/approval/sip')
          })
        } else
          swal({
            title: `${res.data}`,
            icon: 'error',
          })
      })
      .catch(function (error) {
        if (error.response) {
          swal({
            title: `${t(error.response.data.message)}`,
            icon: 'error',
          })
        }
      })
      .finally(() => setBtnLoading(false))
  }
  const handleApprove = async () => {
    setBtnLoading(true)

    const tempfiles: any[] = []
    attachment?.forEach((data: any, _index: any) => {
      tempfiles.push(data)
      if (tempfiles?.length > -1) {
        const temp = data?.file_r.split(',')
        if (temp[1] != undefined) tempfiles[_index].file_r = temp[1]
      }
    })
    const tempid: string[] = []
    addedOrder.forEach((id) => {
      tempid.push(id.order_sub_item_id || id.id)
    })

    await approveSIP(parseInt(params.id!), localStorage.getItem('credential'), {
      id_pengajuan_order: idPengajuan,
      customer: orderPelangganValue,
      perihal: perihal,
      estimate_date: perihalTanggal,
      valid_date_from: dateFrom,
      valid_date_to: dateTo,
      order_sub_detail_id: tempid,
      lang: lang,
      attachments: tempfiles,
      lain_lain: lain,
      kepada: kepada,
      signer_name: signername,
      signer_position: singerposition,
      payment_method_info: paymentMethod,
      body_content: bodyContent,
      footer_content: footerContent,
      is_update: true,
      reviewer_ids: reviewers?.map((item: any) => item.user_id),
      approver_ids: reviewers?.map((item: any) => item.user_id),
    })
      .then((res: any) => {
        dispath(setGetNotif(!notif))
        if (!res.data.error) {
          swal({
            title: `${t(res.data.message)}`,
            icon: 'success',
          }).then(() => {
            getSIP()
          })
        } else {
          if (res.data.match(/League\\Flysystem\\Filesystem::delete(): Argument #1/g)) {
            swal({
              title: t('Error-pengirimanKhusus'),
              icon: 'error',
            })
          } else {
            swal({
              title: t(res.data),
              icon: 'error',
            })
          }
        }
      })
      .catch(function (error: any) {
        if (error.response) {
          swal({
            title: `${t(error.response.data.message)}`,
            icon: 'error',
          })
        }
      })
      .finally(() => {
        setBtnLoading(false)
        setShowApprove(false)
      })
  }
  const handleReject = async () => {
    setBtnLoading(true)
    await rejectSIP(parseInt(params.id!), rejectNote, i18next.language)
      .then((res: any) => {
        dispath(setGetNotif(!notif))
        if (!res.data.error) {
          swal({
            title: `${t('SIP Rejected Success')}`,
            icon: 'success',
          }).then(() => {
            navigate('/approval/sip')
            // disableBtn()
            setShowReject(false)
          })
        } else
          swal({
            title: `${res.data}`,
            icon: 'error',
          })
      })
      .catch(function (error) {
        if (error.response) {
          swal({
            title: `${t(error.response.data.message)}`,
            icon: 'error',
          })
        }
      })
      .finally(() => setBtnLoading(false))
  }

  const postGenerateOTP = async () => {
    await generateOTP(parseInt(params.id!))
      .then((res: any) => {
        swal({
          title: `${t(res.data.message)}`,
          icon: 'success',
        })
      })
      .catch((error: any) => {
        if (error.response.data.message.match(':')) {
          const msg = error.response.data.message
          swal({
            closeOnClickOutside: false,
            title: t(msg),
            icon: 'error',
          })
        } else {
          swal({
            closeOnClickOutside: false,
            title: t(error.response.data.message),
            icon: 'error',
          })
        }
        setBtnLoading(false)
      })
  }
  const postSigningDocument = (otpCode: string) => {
    setBtnLoading(true)
    signingDocument(parseInt(params.id!), {
      otpCode: otpCode,
      credentials: localStorage.getItem('credential'),
    })
      .then((res: any) => {
        swal({
          title: `${t(res.data.message)}`,
          icon: 'success',
        })
        navigate('/approval/sip')
      })
      .catch((error: any) => {
        if (error.response.data.message.match(':')) {
          const msg = error.response.data.message
          swal({
            closeOnClickOutside: false,
            title: t(msg),
            icon: 'error',
          })
        } else {
          swal({
            closeOnClickOutside: false,
            title: t(error.response.data.message),
            icon: 'error',
          })
        }
      })
      .finally(() => setBtnLoading(false))
  }

  const [loadingDownloadDraft, setLoadingDownloadDraft] = useState(false)
  const handleDownloadDraft = async () => {
    if(loadingDownloadDraft) return
    try {
      setLoadingDownloadDraft(true)

      const response = await unduhSIP(
        parseInt(params.id!),
        i18next.language
      );
      const href = URL.createObjectURL(response.data)

      let file_name = `11${SIPNumber}_${customerName}.pdf`

      if ([4,5,6,7,8,9,11].includes(status)) {
        file_name = 'SIP_' + file_name
      } else {
        file_name = 'SIP_DRAFT_' + file_name
      }

      const link = document.createElement('a')
      link.href = href
      link.setAttribute('download', file_name)
      document.body.appendChild(link)
      link.click()

      document.body.removeChild(link)
      URL.revokeObjectURL(href)
      setLoadingDownloadDraft(false)
    } catch (error) {
      setLoadingDownloadDraft(false)
      swal({
        title: t('failed'),
        icon: 'error',
      })
    }
  }

  const [showModalHistory, setShowModalHistory] = useState(false)

  return (
    <>
      <PageTitle breadcrumbs={[]}>{t('page Approval SIP detail')}</PageTitle>

      {!loading && <>
      <div className='card mb-5'>
        <div className='card-body'>
          <ApprovalHistoryPreview reviewers={reviewers} approvers={approvers}/>
        </div>
      </div>
      </>}

      <div className='card'>
        {/* begin::Header */}
        <div className='card-body'>
        {loading ? (
            <div className='d-flex justify-content-center py-10'>
              <div className='lds-ellipsis'>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          ) : (
            <>

            {
              showPreviewForm && <>
              <div style={{padding: '30px', border: '2px dotted #333'}}>
                <ViewLetter data={LetterData} type='sip' />
              </div>

              <div className='card-toolbar mt-10 d-flex justify-content-end'>
                {idPengajuan != '' && (
                    <>
                      <Button
                        onClick={() => {
                          setShowUpload(true)
                          setAttachmentType('sip')
                          setSubOrderID(SIPId || '')
                          ambilAttachment(SIPId, 'sip')
                        }}
                        className='btn btn-primary fw-semibold d-flex align-items-center me-4'
                        data-bs-toggle='tooltip'
                        data-bs-placement='top'
                        data-bs-trigger='hover'
                        title={t('order-lampiran')}
                      >
                        <i className="bi bi-file-earmark-text"></i>
                        <p>{t('order-lampiran')}</p>
                      </Button>
                    </>
                  )}
                </div>

                <ApprovalSIPDetailTable
                  onlyAttachment={true}
                  canUpdate={hakAkses?.update && !tempStatus}
                  sektorID={sektorID}
                  retailFlag={retailFlag}
                  handleShowValue={handleShowValue}
                  removeSubOrder={removeSubOrder}
                  setShow3={setShow3}
                  setSubID={setSubID}
                  formattingTon={formattingTon}
                  setProductName={setProductName}
                  setCityName={setCityName}
                  setProvinceName={setProvinceName}
                  setIDSector={setIDSector}
                  setSubOrderID={setSubOrderID}
                  setParam={setParam}
                  setFileBox={setFileBox}
                  setShowUpload={setShowUpload}
                  setShow1={setShow1}
                  setDetailOrder={setDetailOrder}
                  addedOrder={addedOrder}
                  ambilAttachment={ambilAttachment}
                  setIsLoadingModal={setIsLoadingModal}
                  approveFlag={approveFlag}
                />
              </>
            }
            {
              !showPreviewForm && <>
                <ApprovalSIPDetailForm
                    canUpdate={hakAkses?.update && approveFlag}
                    idPengajuan={idPengajuan}
                    handleShow4={handleShow4}
                    show4={show4}
                    handleClose4={handleClose4}
                    isLoadingModal={isLoadingModal}
                    isFetchingPOApproved={isFetchingPOApproved}
                    perihal={perihal}
                    setPaymentMethod={setPaymentMethod}
                    setDateTo={setDateTo}
                    changes={changes}
                    sektorID={sektorID}
                    setSignerPositon={setSignerPositon}
                    singerposition={singerposition}
                    customerAddress={customerAddress}
                    customerCode={customerCode}
                    setKepada={setKepada}
                    setPerihalTanggal={setPerihalTanggal}
                    setDateFrom={setDateFrom}
                    setSignerName={setSignerName}
                    signername={signername}
                    customerName={customerName}
                    setShow4={setShow4}
                    getOrder={getOrder}
                    numberURL={numberURL}
                    paginateNumber={paginateNumber}
                    fullPO={fullPO}
                    dateFrom={dateFrom}
                    dateTo={dateTo}
                    paymentMethod={paymentMethod}
                    kepada={kepada}
                    perihalTanggal={perihalTanggal}/>

                <ApprovalSIPDetailLetterContent
                  canUpdate={hakAkses?.update && approveFlag}
                  setFooterContent={setFooterContent}
                  footerContent={footerContent}
                  setLain={setLain}
                  lain={lain}
                  setBodyContent={setBodyContent}
                  bodyContent={bodyContent}
                />

                <hr />

                <div className='card-toolbar mt-10 d-flex justify-content-end'>
                {(approveFlag && hakAkses?.update && orderSelect.length > 0 && !tempStatus) && (
                  <Button
                    onClick={() => {
                      handleShow2()
                    }}
                    className='btn btn-primary fw-semibold d-flex align-items-center me-4'
                    data-bs-toggle='tooltip'
                    data-bs-placement='top'
                    data-bs-trigger='hover'
                    title={t('kontrak-tambah') + ' Item'}
                    // data-bs-toggle='modal'
                    // data-bs-target='#kt_modal_invite_friends'
                  >
                    <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                    <p>{t('order-tambah')} Item</p>
                  </Button>
                )}
                {idPengajuan != '' && (
                  <>
                    <Button
                      onClick={() => {
                        setShowUpload(true)
                        setAttachmentType('sip')
                        setSubOrderID(SIPId || '')
                        ambilAttachment(SIPId, 'sip')
                      }}
                      className='btn btn-primary fw-semibold d-flex align-items-center me-4'
                      data-bs-toggle='tooltip'
                      data-bs-placement='top'
                      data-bs-trigger='hover'
                      title={t('order-lampiran')}
                    >
                      <i className="bi bi-file-earmark-text"></i>
                      <p>{t('order-lampiran')}</p>
                    </Button>
                  </>
                )}

                <Button
                  variant='primary'
                  className='ms-2'
                  title={t('history-sip-amendment')}
                  onClick={() => {
                    setShowModalHistory(true)
                  }}
                >
                  <KTSVG
                    path='/media/icons/duotune/file-earmark-arrow-down-fill.svg'
                    className='svg-icon-3'
                  />
                  {t('history-sip-amendment')}
                </Button>
              </div>

              <ApprovalSIPDetailTable
                canUpdate={hakAkses?.update && !tempStatus}
                sektorID={sektorID}
                retailFlag={retailFlag}
                handleShowValue={handleShowValue}
                removeSubOrder={removeSubOrder}
                setShow3={setShow3}
                setSubID={setSubID}
                formattingTon={formattingTon}
                setProductName={setProductName}
                setCityName={setCityName}
                setProvinceName={setProvinceName}
                setIDSector={setIDSector}
                setSubOrderID={setSubOrderID}
                setParam={setParam}
                setFileBox={setFileBox}
                setShowUpload={setShowUpload}
                setShow1={setShow1}
                setDetailOrder={setDetailOrder}
                addedOrder={addedOrder}
                ambilAttachment={ambilAttachment}
                setIsLoadingModal={setIsLoadingModal}
                approveFlag={approveFlag}
              />

                <hr />

                {addedOrder.length >= 1 ? (
                  <>
                    <Row className='mt-5'>
                      <Col md={10}>
                        <Row className='mb-3'>
                          <Col md={3}>
                            <p className='fs-4 mt-2'>{t('Total Kuantum')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={
                                (i18next.language === 'en'
                                  ? totalQuantum?.toLocaleString('en', {maximumFractionDigits: 4})
                                  : totalQuantum?.toLocaleString('id', {
                                      maximumFractionDigits: 4,
                                    })) +
                                ' ' +
                                'Ton'
                              }
                              disabled
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col md={2}></Col>
                    </Row>
                  
                    <Row className=''>
                      <Col md={10}>
                        <Row className='mb-3'>
                          <Col md={3}>
                            <p className='fs-4 mt-2'>{t('Grand Total')}</p>
                          </Col>
                          <Col md={8}>
                            {sektorID != '3' ? (
                              <Form.Control
                                aria-label='Default select example'
                                size='sm'
                                value={
                                  'Rp' + i18next.language === 'en'
                                    ? grandtotal.toLocaleString('en', {maximumFractionDigits: 4})
                                    : grandtotal.toLocaleString('id', {maximumFractionDigits: 4})
                                }
                                disabled
                              />
                            ) : (
                              <Form.Control
                                aria-label='Default select example'
                                size='sm'
                                value={'USD' + PriceFormater(grandtotal)}
                                disabled
                              />
                            )}
                          </Col>
                        </Row>
                      </Col>
                      <Col md={2}></Col>
                    </Row>
                  </>
                ) : (
                  <></>
                )}
              </>
            }

            <hr/>

              <div className='d-flex justify-content-between mt-5'>
                <div>
                  <Button
                    className='me-2'
                    variant='secondary'
                    onClick={() => {
                      if(showPreviewForm){
                        navigate('/approval/sip')
                      }else{
                        setShowPreviewForm(true)
                      }
                    }}
                  >
                    <i className="bi bi-chevron-left"></i>
                     {!approveFlag ? ( t('order-kembali')) : (t('sip-batal'))} 
                  </Button>

                  { (showPreviewForm && hakAkses?.update && approveFlag) && 
                  <Button
                    variant='warning'
                    className='ml-2'
                    onClick={() => setShowPreviewForm(false)}
                    disabled={btnLoading}
                  >
                    <i className="fa fa-pencil"></i>
                    {t('Change')}
                  </Button> }

                  <Button
                    disabled={loadingDownloadDraft}
                    variant='primary'
                    className='ms-2'
                    onClick={handleDownloadDraft}
                  >
                    {
                      loadingDownloadDraft ? <i className='fa fa-spin fa-spinner'></i> : <>
                        <i className='fa fa-download'></i>
                        {[4,5,6,7,8,9,11].includes(status) ? t('donwload-SIP') : t('download-sip')}
                      </>
                    }
                  </Button>
                </div>
                
                <div>
                { (!showPreviewForm) && 
                  <Button
                    variant='primary'
                    className='ml-2'
                    onClick={() => setShowSave(true)}
                    disabled={btnLoading}
                  >
                    <i className="fa fa-save"></i>
                    {t('save-as-draft')}
                  </Button> }
                  {
                    showPreviewForm && <>
                      <Button
                        hidden={singingFlag ? false : true}
                        variant='primary'
                        className='me-2'
                        id='btn-approve'
                        onClick={() => setShowSigning(true)}
                      >
                        <i className="fa fa-signature"></i>
                        {t('Tandatangani')}
                      </Button>

                      {approveFlag && (
                        <>
                          <Button
                            variant='danger'
                            className='me-2'
                            id='btn-reject'
                            onClick={() => setShowReject(true)}
                          >
                            <i className="fa fa-times"></i>
                            {t('order-tolak')}
                          </Button>

                          <Button
                            variant='warning'
                            className='me-2'
                            id='btn-revision'
                            onClick={() => setShowRevision(true)}
                          >
                            <i className="fa fa-edit"></i>
                            {t('order-revisi2')}{hakAkses?.update}
                          </Button>
                          
                          <Button
                            variant='success'
                            className='me-2'
                            id='btn-approve'
                            onClick={() => setShowApprove(true)}
                          >
                            <i className="fa fa-check"></i>
                            {t('setujui')}
                          </Button>
                        </>
                      )}
                    </>
                  }
                </div>
              </div>

              <ApprovalSIPDetailChooseItem addInOrder={addInOrder} orderSelect={orderSelect} onclickCheckBox={onclickCheckBox} sektorID={sektorID} selectedIndex={selectedIndex} isLoadingModal={isLoadingModal} setIndexOrder={setIndexOrder} setShow2={setShow2} show2={show2}/>

              <Modal
                show={show3}
                onHide={() => setShow3(false)}
                centered
                size='xl'
                backdrop='static'
                keyboard={false}
                scrollable
              >
                <Modal.Header closeButton>
                  <Modal.Title>
                    {idSektor != 3 ? provinceName + ', ' + cityName + ' | ' : ''}
                    {productName} | {fixedQuantum} Ton
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <span style={{fontSize: '15px'}} className='fw-bold d-block'>
                    {t('Jadwal')}
                  </span>
                  <AddRemoveJadwal id={subID} is_amendment={'false'} />
                </Modal.Body>
              </Modal>

              <Modal
                show={showDetail}
                onHide={() => setShowDetail(false)}
                centered
                scrollable
                backdrop='static'
              >
                <Modal.Header closeButton>
                  <Modal.Title>{t('Detail Sub Order')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <table className='mb-3'>
                    <tr>
                      <td style={{width: '135px'}}>
                        <h6>Sales Org</h6>
                      </td>
                      <td className='w-50'>
                        <Form.Control
                          value={detailOrder.produsen?.name}
                          type='text'
                          disabled
                          size='sm'
                        />
                      </td>
                    </tr>
                  </table>
                  <table className='mb-3'>
                    <tr>
                      <td style={{width: '135px'}}>
                        <h6>{t('End Customer')}</h6>
                      </td>
                      <td className='w-50'>
                        <Form.Control
                          value={
                            detailOrder?.end_user_multiple
                              ? handleShowValue(detailOrder.end_user)
                              : detailOrder.end_user
                            // detailOrder.end_user_detail?.name
                            //   ? detailOrder.end_user_detail?.name
                            //   : detailOrder.end_user
                          }
                          as='textarea'
                          disabled
                        />
                      </td>
                    </tr>
                  </table>
                  <table className='mb-3'>
                    <tr>
                      <td style={{width: '135px'}}>
                        <h6>{t('sub-order-sektor')}</h6>
                      </td>
                      <td className='w-50'>
                        <Form.Control value={t(detailOrder.sector?.name)} type='text' disabled />
                      </td>
                    </tr>
                  </table>
                  <table className='mb-3'>
                    <tr>
                      <td style={{width: '135px'}}>
                        <h6>{t('sub-order-incoterm1')}</h6>
                      </td>
                      <td className='w-50'>
                        <Form.Control value={detailOrder.incoterm1?.code} type='text' disabled />
                      </td>
                    </tr>
                  </table>
                  {detailOrder.sector?.id == 2 ? (
                    <table className='mb-3'>
                      <tr>
                        <td style={{width: '135px'}}>
                          <h6>{t('sub-order-incoterm2')}</h6>
                        </td>
                        <td className='w-50'>
                          <Form.Control
                            value={
                              detailOrder.incoterm2?.code
                                ? detailOrder.incoterm2?.code
                                : detailOrder.incoterm2_id
                            }
                            type='text'
                            disabled
                          />
                        </td>
                      </tr>
                    </table>
                  ) : (
                    <table
                      className='mb-3'
                      hidden={
                        detailOrder.incoterm2_id == '0' || detailOrder.incoterm2_id == null
                          ? true
                          : false
                      }
                    >
                      <tr>
                        <td style={{width: '135px'}}>
                          <h6>{t('sub-order-incoterm2')}</h6>
                        </td>
                        <td className='w-50'>
                          {detailOrder.incoterm2?.code == null ? (
                            <Form.Control
                              value={
                                detailOrder.incoterm2_id == '0' || detailOrder.incoterm2_id == null
                                  ? ''
                                  : detailOrder.incoterm2_id
                              }
                              type='text'
                              disabled
                            />
                          ) : (
                            <Form.Control
                              value={detailOrder.incoterm2?.code ? detailOrder.incoterm2?.code : ''}
                              type='text'
                              disabled
                            />
                          )}
                        </td>
                      </tr>
                    </table>
                  )}

                  {sektorID == '3' ? (
                    <table className='mb-3'>
                      <tr>
                        <td style={{width: '135px'}}>
                          <h6>{t('sub-order-negara')}</h6>
                        </td>
                        <td className='w-50'>
                          <Form.Control type='text' value={detailOrder.country_desc} disabled />
                        </td>
                      </tr>
                    </table>
                  ) : (
                    <>
                      <table className='mb-3'>
                        <tr>
                          <td style={{width: '135px'}}>
                            <h6>{t('sub-order-provinsi')}</h6>
                          </td>
                          <td className='w-50'>
                            <Form.Control
                              type='text'
                              value={detailOrder.province?.region_name}
                              disabled
                            />
                          </td>
                        </tr>
                      </table>
                      <table className='mb-3'>
                        <tr>
                          <td style={{width: '135px'}}>
                            <h6>{t('sub-order-kota')}</h6>
                          </td>
                          <td className='w-50'>
                            <Form.Control type='text' value={detailOrder.city?.city_name} disabled />
                          </td>
                        </tr>
                      </table>
                    </>
                  )}
                  {detailOrder.sector?.id == 2 ? (
                    <table className='mb-3'>
                      <tr>
                        <td style={{width: '135px'}}>
                          <h6>{t('sub-order-gudang')}</h6>
                        </td>
                        <td className='w-50'>
                          <Form.Control value={detailOrder.plant_desc} type='text' disabled />
                        </td>
                      </tr>
                    </table>
                  ) : (
                    ''
                  )}

                  <table className='mb-3'>
                    <tr>
                      <td style={{width: '135px'}}>
                        <h6>{t('sub-order-jenis')}</h6>
                      </td>
                      <td className='w-50'>
                        <Form.Control value={detailOrder.product_type_desc} type='text' disabled />
                      </td>
                    </tr>
                  </table>
                  <table className='mb-3'>
                    <tr>
                      <td style={{width: '135px'}}>
                        <h6>{t('sub-order-produk')}</h6>
                      </td>
                      <td className='w-50'>
                        <Form.Control value={detailOrder.product_name} type='text' disabled />
                      </td>
                    </tr>
                  </table>
                  <table className='mb-3'>
                    <tr>
                      <td style={{width: '135px'}}>
                        <h6>{t('sub-order-spek')}</h6>
                      </td>
                      <td className='w-50'>
                        <FieldProductSpec data={detailOrder.product_spec} />
                      </td>
                    </tr>
                  </table>
                  <table className='mb-3'>
                    <tr>
                      <td style={{width: '135px'}}>
                        <h6>{t('sub-order-hargaP')}</h6>
                      </td>
                      <td className='w-50'>
                        <Form.Control
                          value={
                            i18next.language === 'en'
                              ? parseFloat(detailOrder.fixed_price).toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                })
                              : parseFloat(detailOrder.fixed_price).toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                })
                          }
                          type='text'
                          disabled
                        />
                      </td>
                    </tr>
                  </table>
                  <table className='mb-3'>
                    <tr>
                      <td style={{width: '135px'}}>
                        <h6>{t('sub-order-kuantum')}</h6>
                      </td>
                      <td className='w-50'>
                        <Form.Control
                          value={
                            (i18next.language === 'en'
                              ? parseInt(detailOrder.fixed_quantum).toLocaleString('en', {
                                  maximumFractionDigits: 4,
                                })
                              : parseInt(detailOrder.fixed_quantum).toLocaleString('id', {
                                  maximumFractionDigits: 4,
                                })) + (detailOrder.sector_id === 3 ? ' MT' : ' Ton')
                          }
                          type='text'
                          disabled
                        />
                      </td>
                    </tr>
                  </table>
                  <table className='mb-3'>
                    <tr>
                      <td style={{width: '135px'}}>
                        <h6>{t('sub-order-catatan')}</h6>
                      </td>
                      <td className='w-50'>
                        <Form.Control
                          as='textarea'
                          style={{height: '40px'}}
                          value={detailOrder.notes}
                          type='text'
                          disabled
                        />
                      </td>
                    </tr>
                  </table>
                  <table className='mb-3'>
                    <tr>
                      <td style={{width: '135px'}}>
                        <h6>{t('sub-order-payment1')}</h6>
                      </td>
                      <td className='w-50'>
                        <Form.Control value={detailOrder.payment_type_1_desc} type='text' disabled />
                      </td>
                    </tr>
                  </table>
                  <table className='mb-5'>
                    <tr>
                      <td style={{width: '135px'}}>
                        <h6>{t('sub-order-payment2')}</h6>
                      </td>
                      <td className='w-50'>
                        <Form.Control value={detailOrder.payment_type_2_desc} type='text' disabled />
                      </td>
                    </tr>
                  </table>
                </Modal.Body>
              </Modal>

              <Modal
                size='lg'
                show={showUpload}
                onHide={() => {
                  setShowUpload(false)
                  setFileBox({})
                }}
                backdrop='static'
                keyboard={false}
                centered
              >
                <Modal.Header closeButton>
                  <Modal.Title>
                    {
                      attachmentType == 'order-item' ?
                    (fileBox?.product_name
                      ? (fileBox.province ? fileBox.province?.region_name : '') +
                        (fileBox.city ? ', ' + fileBox.city?.city_name : '') +
                        (fileBox.province ? ' | ' : '') +
                        fileBox.product_name +
                        (fileBox.request_quantum ? ' | ' + fileBox.request_quantum + ' Ton' : '')
                      : t('File Box'))
                      : <span>{t('File Box')}</span>
                    }
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {isLoadingModal ? (
                    <Skeleton width={100} height={30} />
                  ) : (
                    <>
                      <Row>
                        <Col sm={6}>
                          <table className='mb-3'>
                            <tr>
                              <td style={{width: '120px'}}>
                                <h6>{t('order-fileUnggah')}</h6>
                              </td>
                              <td className='w-75'>
                                <InputFile
                                  setFileName={setNamaFile}
                                  setFiles={setFiles}
                                  isBase64={false}
                                />
                              </td>
                            </tr>
                          </table>
                          <table className='mb-3'>
                            <tr>
                              <td style={{width: '120px'}}>
                                <h6>{t('order-keterangan')}</h6>
                              </td>
                              <td className='w-75'>
                                <Form.Control
                                  type='text'
                                  placeholder={t('order-keterangan')}
                                  onChange={(e: any) => setDescription(e.target.value)}
                                  value={description}
                                />
                              </td>
                            </tr>
                          </table>
                          <table className='mb-3'>
                            <tr>
                              <td>
                                <h6 className='me-11'>{t('Private')}</h6>
                              </td>
                              <td className='w-75 d-flex justify-content-start'>
                                <Form.Check
                                  reverse
                                  name='isPrivate'
                                  type='checkbox'
                                  className='mt-5 mb-2'
                                  onClick={() => {
                                    setIsPrivate(!isPrivate)
                                  }}
                                  id='isPrivate'
                                />
                              </td>
                            </tr>
                          </table>
                          <table className='mb-3' hidden={isPrivate ? false : true}>
                            <tr>
                              <td style={{width: '120px'}}>
                                <h6>{t('Akses Role')}</h6>
                              </td>
                              <td className='w-75' style={{maxWidth: '274px'}}>
                                <MultiSelect
                                  key={isPrivate.toString()}
                                  options={fullRole?.map((item: any) => {
                                    return {label: item.label, value: item.value}
                                  })}
                                  value={tempRole}
                                  onChange={(e: any) => setTempRole(e)}
                                  labelledBy='Select'
                                />
                              </td>
                            </tr>
                          </table>
                          <div className='d-flex justify-content-end'>
                            <Button
                              variant='primary'
                              className='w-100'
                              onClick={() => handleUpload()}
                              disabled={btnLoading}
                            >
                              {btnLoading ? (
                                <Spinner animation='border' variant='light' size='sm' />
                              ) : (
                                t('order-kirim')
                              )}
                            </Button>
                          </div>
                        </Col>
                      </Row>
                      <div className='table-responsive mt-4 bdr'>
                        <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                          <thead className='fw-bold border-bottom'>
                            <tr className=''>
                              <th className='text-center'>{t('order-noo')}</th>
                              <th className='text-center'>{t('order-keterangan')}</th>
                              <th className='text-center'>{t('order-tglUpload')}</th>
                              {/* <th className='text-center'>{t('User Code')}</th> */}
                              <th className='text-center'>{t('order-user')}</th>
                              <th className='text-center'>{t('Akses Role')}</th>
                              <th className='text-center'>{t('order-aksi')}</th>
                            </tr>
                          </thead>
                          {allFiles.map((data: any, _index: number) => (
                            <tbody key={data?.id ?? _index}>
                              <tr className=''>
                                <td className='text-center'>
                                  <label>{_index + 1}</label>
                                </td>
                                <td className='text-center'>
                                  <label>{data.description}</label>
                                </td>
                                <td className='text-center'>
                                  <label>{dateformat(data.updated_at)}</label>
                                </td>
                                {/* <td className='text-center'>
                                  <label>{data.user?.customer_code || data.user?.nama_pengguna}</label>
                                </td> */}
                                <td className='text-center'>
                                  {data.user?.customer_code == null ? (
                                    <label>{data.user?.name}</label>
                                  ) : (
                                    <label>{data.user?.customer?.name}</label>
                                  )}
                                </td>
                                <td className='text-center'>
                                  {data.private ? (
                                    data.roles.length > 0 ? (
                                      <PopoverText
                                        content={handleShowRoleName(data.roles)}
                                        index={_index}
                                        className='desc-slice'
                                      />
                                    ) : (
                                      'Private'
                                    )
                                  ) : (
                                    'Public'
                                  )}
                                </td>
                                <td className='text-center'>
                                  <button
                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                    data-bs-toggle='tooltip'
                                    data-bs-placement='top'
                                    data-bs-trigger='hover'
                                    title={t('unduh')}
                                    onClick={() =>
                                      handleDownloadAttachment(
                                        data.file_path
                                      )
                                    }
                                  >
                                    <KTSVG
                                      path='/media/icons/duotune/arrow-down-square-fill.svg'
                                      className='svg-icon-3'
                                    />
                                  </button>
                                  {(hakAkses?.attachment_delete ||
                                    CheckSameIDAttachment(data.user_role_flag)) && (
                                    <button
                                      onClick={() => deleteAttachment(data.id)}
                                      className={`btn btn-icon btn-bg-light btn-active-color-primary btn-sm`}
                                      data-bs-toggle='tooltip'
                                      data-bs-placement='top'
                                      data-bs-trigger='hover'
                                      title={t('Hapus')}
                                    >
                                      <KTSVG
                                        path='/media/icons/duotune/trash-fill.svg'
                                        className='svg-icon-3'
                                      />
                                    </button>
                                  )}
                                </td>
                              </tr>
                            </tbody>
                          ))}
                        </table>
                      </div>
                    </>
                  )}
                </Modal.Body>
              </Modal>`

              <Modal
                show={show1}
                onHide={handleClose1}
                backdrop='static'
                keyboard={false}
                centered
                scrollable
                size='xl'
              >
                <Modal.Header closeButton>
                  <Modal.Title>Detail SIP</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {detailOrder?.sector?.id == 1 && (
                    <Row>
                      <Col md='6'>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-item')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={detailOrder?.id}
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-produsen')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={detailOrder?.produsen?.name}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>

                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={detailOrder?.incoterm1?.code}
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={detailOrder?.province?.region_name}
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={detailOrder?.product_type_desc}
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4} className='d-flex align-items-center'>
                            <p className='fs-6'>{t('Kuantum Pengajuan')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={
                                i18next.language === 'en'
                                  ? detailOrder?.request_quantum?.toLocaleString('en', {
                                      maximumFractionDigits: 4,
                                    }) + ' Ton'
                                  : detailOrder?.request_quantum?.toLocaleString('id', {
                                      maximumFractionDigits: 4,
                                    }) + ' Ton'
                              }
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4} className='d-flex align-items-center'>
                            <p className='fs-6'>{t('sub-order-kuantumD')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={
                                i18next.language === 'en'
                                  ? detailOrder?.fixed_quantum?.toLocaleString('en', {
                                      maximumFractionDigits: 4,
                                    }) + ' Ton'
                                  : detailOrder?.fixed_quantum?.toLocaleString('id', {
                                      maximumFractionDigits: 4,
                                    }) + ' Ton'
                              }
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={detailOrder?.payment_type_1_desc}
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4} className='d-flex align-items-center'>
                            <p className='fs-6'>{t('sub-order-spek')}</p>
                          </Col>
                          <Col md={8}>
                            <FieldProductSpec data={detailOrder?.product_spec} />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('segment')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              type='text'
                              value={t(detailOrder.segment_name)}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('alasan perpanjangan')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={detailOrder?.amandement_notes}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col md='6'>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('End Customer')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              as='textarea'
                              size='sm'
                              style={{height: '40px'}}
                              value={
                                detailOrder?.end_user_multiple
                                  ? handleShowValue(detailOrder.end_user)
                                  : detailOrder.end_user
                              }
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={t(detailOrder?.sector?.name)}
                              disabled
                            />
                          </Col>
                        </Row>

                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                          </Col>
                          <Col md={8}>
                            {detailOrder?.incoterm2 == null ? (
                              <Form.Control
                                size='sm'
                                aria-label='Default select example'
                                value={
                                  detailOrder?.incoterm2_id == null || detailOrder?.incoterm2_id == '0'
                                    ? ''
                                    : detailOrder?.incoterm2_id
                                }
                                disabled
                              />
                            ) : (
                              <Form.Control
                                aria-label='Default select example'
                                size='sm'
                                value={detailOrder?.incoterm2?.code ? detailOrder?.incoterm2?.code : ''}
                                disabled
                              />
                            )}
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={detailOrder?.city?.city_name}
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={detailOrder?.product_name}
                              disabled
                            />
                          </Col>
                        </Row>

                        <Row className='mb-4'>
                          <Col md={4} className='d-flex align-items-center'>
                            <p className='fs-6'>{t('sub-order-hargaP')}/Ton</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={
                                'Rp' + i18next.language === 'en'
                                  ? detailOrder?.request_price?.toLocaleString('en', {
                                      maximumFractionDigits: 4,
                                    })
                                  : detailOrder?.request_price?.toLocaleString('id', {
                                      maximumFractionDigits: 4,
                                    })
                              }
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='mb-3'>
                          <Col md={4} className='d-flex align-items-center'>
                            <p className='fs-6'>{t('sub-order-hargaD')}/Ton</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={
                                'Rp' + i18next.language === 'en'
                                  ? detailOrder?.fixed_price?.toLocaleString('en', {
                                      maximumFractionDigits: 4,
                                    })
                                  : detailOrder?.fixed_price?.toLocaleString('id', {
                                      maximumFractionDigits: 4,
                                    })
                              }
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={detailOrder?.payment_type_2_desc}
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='my-7'>
                          <Col sm={6} className='d-flex '>
                            <Row sm={8} className='d-flex align-items-center'>
                              <p className='fs-6'>{t('termasuk-ppn')}</p>
                            </Row>
                            <Row
                              sm={4}
                              className='d-flex justify-content-start align-items-center ms-4'
                            >
                              <Form.Check
                                reverse
                                name='ppn'
                                disabled
                                type='checkbox'
                                id='ckbox-ppn'
                                checked={detailOrder?.include_ppn}
                              />
                            </Row>
                          </Col>
                          <Col sm={6} className='d-flex'>
                            <Row sm={8} className='d-flex align-items-center'>
                              <p className=' fs-6'>{t('Formulated Price')}</p>
                            </Row>
                            <Row
                              sm={4}
                              className='d-flex justify-content-start align-items-center ms-4'
                            >
                              <Form.Check
                                reverse
                                name='formula_Price'
                                type='checkbox'
                                disabled
                                checked={detailOrder?.is_formulated_price}
                                id='formula_Price'
                              />
                            </Row>
                          </Col>
                        </Row>

                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              as='textarea'
                              style={{height: '40px'}}
                              value={detailOrder?.notes}
                              disabled
                            />
                          </Col>
                        </Row>

                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('tanggal perpanjangan')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={detailOrder?.extension_date}
                              type={detailOrder?.extension_date ? 'date' :'text'}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>

                        {/* <Row className='mb-4'>
                                      <Col md={4}>
                                        <p className='mt-3 fs-6'>{t('termasuk-ppn')}</p>
                                      </Col>
                                      <Col md={8} className='d-flex justify-content-start'>
                                      <Form.Check
                                        reverse
                                        name='ppn'
                                        className='mt-3 mb-2'
                                        type='checkbox'
                                        id='ckbox-ppn'
                                        checked={detailOrder?.include_ppn}
                                      />
                                      </Col>
                                    </Row> */}
                      </Col>
                    </Row>
                  )}

                  {detailOrder?.sector?.id == 2 && (
                    <Row>
                      <Col md='6'>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-item')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={detailOrder?.id}
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-produsen')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={detailOrder?.produsen?.name}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={detailOrder?.incoterm1?.code}
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={detailOrder?.province?.region_name}
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-gudang')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={detailOrder?.plant_desc}
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              as='textarea'
                              style={{height: '40px'}}
                              value={detailOrder?.product_name}
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-kuantum')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={
                                i18next.language === 'en'
                                  ? detailOrder?.request_quantum?.toLocaleString('en', {
                                      maximumFractionDigits: 4,
                                    }) + ' Ton'
                                  : detailOrder?.request_quantum?.toLocaleString('id', {
                                      maximumFractionDigits: 4,
                                    }) + ' Ton'
                              }
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={detailOrder?.payment_type_1_desc}
                              disabled
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col md='6'>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('End Customer')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              as='textarea'
                              size='sm'
                              style={{height: '40px'}}
                              value={
                                detailOrder?.end_user_multiple
                                  ? handleShowValue(detailOrder.end_user)
                                  : detailOrder.end_user
                              }
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={t(detailOrder?.sector?.name)}
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                          </Col>
                          <Col md={8}>
                            {detailOrder?.incoterm2 == null ? (
                              <Form.Control
                                size='sm'
                                aria-label='Default select example'
                                value={
                                  detailOrder?.incoterm2_id == null || detailOrder?.incoterm2_id == '0'
                                    ? ''
                                    : detailOrder?.incoterm2_id
                                }
                                disabled
                              />
                            ) : (
                              <Form.Control
                                aria-label='Default select example'
                                size='sm'
                                value={detailOrder?.incoterm2?.code ? detailOrder?.incoterm2?.code : ''}
                                disabled
                              />
                            )}
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={detailOrder?.city?.city_name}
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={detailOrder?.product_type_desc}
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4} className='d-flex align-items-center'>
                            <p className='fs-6'>{t('sub-order-spek')}</p>
                          </Col>
                          <Col md={8}>
                            <FieldProductSpec data={detailOrder?.product_spec} />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='fs-6 mt-3'>{t('sub-order-hargaP')}/Ton</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={
                                'Rp' + i18next.language === 'en'
                                  ? detailOrder?.request_price?.toLocaleString('en', {
                                      maximumFractionDigits: 4,
                                    })
                                  : detailOrder?.request_price?.toLocaleString('id', {
                                      maximumFractionDigits: 4,
                                    })
                              }
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              as='textarea'
                              style={{height: '40px'}}
                              value={detailOrder?.notes}
                              disabled
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  )}

                  {detailOrder?.sector?.id == 3 && (
                    <Row>
                      <Col md='6'>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-item')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={detailOrder?.id}
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-produsen')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={detailOrder?.produsen?.name}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-incoterm1')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={detailOrder?.incoterm1?.code}
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={detailOrder?.province?.region_name}
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={detailOrder?.product_type_desc}
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4} className='d-flex align-items-center'>
                            <p className='fs-6'>{t('Kuantum Pengajuan')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={
                                i18next.language === 'en'
                                  ? detailOrder?.request_quantum?.toLocaleString('en', {
                                      maximumFractionDigits: 4,
                                    }) + ' MT'
                                  : detailOrder?.request_quantum?.toLocaleString('id', {
                                      maximumFractionDigits: 4,
                                    }) + ' MT'
                              }
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4} className='d-flex align-items-center'>
                            <p className='fs-6'>{t('sub-order-kuantumD')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={
                                i18next.language === 'en'
                                  ? detailOrder?.fixed_quantum?.toLocaleString('en', {
                                      maximumFractionDigits: 4,
                                    }) + ' MT'
                                  : detailOrder?.fixed_quantum?.toLocaleString('id', {
                                      maximumFractionDigits: 4,
                                    }) + ' MT'
                              }
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={detailOrder?.payment_type_1_desc}
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4} className='d-flex align-items-center'>
                            <p className='fs-6'>{t('sub-order-spek')}</p>
                          </Col>
                          <Col md={8}>
                            <FieldProductSpec data={detailOrder?.product_spec} />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              as='textarea'
                              style={{height: '40px'}}
                              value={detailOrder?.notes}
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('alasan perpanjangan')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={detailOrder?.amandement_notes}
                              type='text'
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col md='6'>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('End Customer')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              as='textarea'
                              size='sm'
                              style={{height: '40px'}}
                              value={
                                detailOrder?.end_user_multiple
                                  ? handleShowValue(detailOrder.end_user)
                                  : detailOrder.end_user
                              }
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={t(detailOrder?.sector?.name)}
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-incoterm2')}</p>
                          </Col>
                          <Col md={8}>
                            {detailOrder?.incoterm2 == null ? (
                              <Form.Control
                                size='sm'
                                aria-label='Default select example'
                                value={
                                  detailOrder?.incoterm2_id == null || detailOrder?.incoterm2_id == '0'
                                    ? ''
                                    : detailOrder?.incoterm2_id
                                }
                                disabled
                              />
                            ) : (
                              <Form.Control
                                aria-label='Default select example'
                                size='sm'
                                value={detailOrder?.incoterm2?.code ? detailOrder?.incoterm2?.code : ''}
                                disabled
                              />
                            )}
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={detailOrder?.city?.city_name}
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={detailOrder?.product_name}
                              disabled
                            />
                          </Col>
                        </Row>

                        <Row className='mb-4'>
                          <Col md={4} className='d-flex align-items-center'>
                            <p className='fs-6'>{t('sub-order-hargaP')}/MT</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={'USD' + PriceFormater(detailOrder?.request_price) + '/MT'}
                              disabled
                            />
                          </Col>
                        </Row>

                        <Row className='mb-3'>
                          <Col md={4} className='d-flex align-items-center'>
                            <p className='fs-6'>{t('sub-order-hargaD')}/MT</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={'USD' + PriceFormater(detailOrder?.fixed_price) + '/MT'}
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              aria-label='Default select example'
                              size='sm'
                              value={detailOrder?.payment_type_2_desc}
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='my-7'>
                          <Col sm={4} className='d-flex align-items-center'>
                            <p className=' fs-6'>{t('Formulated Price')}</p>
                          </Col>
                          <Col sm={8} className='d-flex justify-content-start align-items-center'>
                            <Form.Check
                              reverse
                              name='formula_Price'
                              type='checkbox'
                              checked={detailOrder?.is_formulated_price}
                              id='formula_Price'
                              disabled
                            />
                          </Col>
                        </Row>
                        <Row className='mb-4'>
                          <Col md={4}>
                            <p className='mt-3 fs-6'>{t('tanggal perpanjangan')}</p>
                          </Col>
                          <Col md={8}>
                            <Form.Control
                              value={detailOrder?.extension_date}
                              type={detailOrder?.extension_date ? 'date' :'text'}
                              disabled
                              size='sm'
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  )}
                </Modal.Body>
              </Modal>

              <Modal show={showSave} onHide={() => setShowSave(false)} centered backdrop='static'>
                <Modal.Header closeButton>
                  <Modal.Title>{t('save-as-draft')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <h3 className='text-center mb-5'>{t('save-as-draft')}?</h3>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant='secondary' onClick={() => setShowSave(false)}>
                    {t('sip-batal')}
                  </Button>
                  <Button variant='primary' onClick={handleSave} disabled={btnLoading}>
                    {btnLoading ? <Spinner animation='border' size='sm' /> : t('save')}
                  </Button>
                </Modal.Footer>
              </Modal>

              <Modal show={showRevision} onHide={() => setShowRevision(false)} centered backdrop='static'>
                <Modal.Header closeButton>
                  <Modal.Title>{t('alasan-revisi')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <FloatingLabel controlId='floatingTextarea2' label={t('order-alasan')}>
                    <Form.Control
                      as='textarea'
                      placeholder={t('Tinggal-pesan')}
                      style={{height: '100px'}}
                      onChange={(e: any) => {
                        setRevisionNote(e.target.value)
                      }}
                    />
                  </FloatingLabel>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant='secondary' onClick={() => setShowRevision(false)}>
                    {t('sip-batal')}
                  </Button>
                  <Button variant='warning' onClick={handleRevision} disabled={btnLoading}>
                    {btnLoading ? <Spinner animation='border' size='sm' /> : t('order-revisi2')}
                  </Button>
                </Modal.Footer>
              </Modal>

              <Modal show={showReject} onHide={() => setShowReject(false)} centered backdrop='static'>
                <Modal.Header closeButton>
                  <Modal.Title>{t('order-alasanTolak')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <FloatingLabel controlId='floatingTextarea2' label={t('order-alasan')}>
                    <Form.Control
                      as='textarea'
                      placeholder={t('Tinggal-pesan')}
                      style={{height: '100px'}}
                      onChange={(e: any) => setRejectNote(e.target.value)}
                    />
                  </FloatingLabel>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant='secondary' onClick={() => setShowReject(false)}>
                    {t('cancel')}
                  </Button>
                  <Button variant='danger' onClick={handleReject} disabled={btnLoading}>
                    {btnLoading ? <Spinner animation='border' size='sm' /> : t('order-tolak2')}
                  </Button>
                </Modal.Footer>
              </Modal>

              <Modal show={showApprove} onHide={() => setShowApprove(false)} centered backdrop='static'>
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                  <h3 className='text-center mb-5'>{t('Approve')}?</h3>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant='secondary me-2' onClick={() => setShowApprove(false)}>
                    {t('Tidak')}
                  </Button>
                  <Button variant='success' onClick={handleApprove} disabled={btnLoading}>
                    {btnLoading ? <Spinner animation='border' size='sm' /> : t('Ya')}
                  </Button>
                </Modal.Footer>
              </Modal>

              <ModalInputAndGenerateOTP
                isLoading={btnLoading}
                show={showSigning}
                onHide={() => setShowSigning(false)}
                onGenerateOTP={() => postGenerateOTP()}
                onSubmitOTP={(otp) => postSigningDocument(otp)}
              />

              <SIPHistories
                show={showModalHistory}
                id={params.id}
                onCloseModal={() => setShowModalHistory(false)}
              />

            </>
          )}
        </div>
      </div>
    </>
  )
}

export {ApprovalSIPDetail}
